import React from "react";

function MessageToStudent() {
  return (
    <>
      <div className="MessageToStudentContainer" data-aos="fade-up">
        <div id="Heading">
          <h1>Message To Student</h1>
        </div>

        <div className="MessageToStudent" data-aos="fade-up">
          <div className="MessageLeft">
            <div className="Message">
              <p>
                I am pleased to welcome you to the University Department of Education, Vinoba Bhave University, Hazaribag, Jharkhand. 
                We offer the 4-year Integrated B.A./B.Sc.-B.Ed. course and the M.Ed. course.
                <br />
                <br />
                Our aim is to build future leaders for the education sector by imparting world-class teacher education. 
                The department is progressing by leaps and bounds under the able and dynamic leadership of our Vice Chancellor.
              </p>
            </div>
            <div className="Signature">
              <p>Dr. Md. Tanwir Yunus</p>
              <p>Professor</p>
            </div>
          </div>
          <div className="MessageRight">
            <img src="/Images/Members/Tanwir.jpeg" alt="director-img" />
          </div>
        </div>
      </div>
    </>
  );
}

export default MessageToStudent;
